<template>
  <div class="tenant-layout">
    <v-navigation-drawer app v-model="drawer" dark class="app-drawer">
      <v-list dense nav>
        <v-list-item class="px-2 mb-2">
           <img
             src="@/assets/logo-itpv-manager.png"
             alt="iTPV Manager"
             class="drawer-logo"
           >
        </v-list-item>

        <div class="drawer-section">GENERAL</div>

        <!-- Elementos de navegación -->
        <v-list-item
          v-for="item in visibleMenuItems"
          :key="item.title"
          :to="item.route"
          link
          class="drawer-item"
          active-class="drawer-item--active"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <div v-if="hasModuleGroups" class="drawer-section">MÓDULOS</div>

        <v-list-group
          v-if="visibleInventoryMenuItems.length"
          v-model="inventoryOpen"
          prepend-icon="mdi-archive-outline"
          color="white"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Inventario</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="item in visibleInventoryMenuItems"
            :key="item.title"
            :to="item.route"
            link
            class="drawer-item"
            active-class="drawer-item--active"
          >
            <v-list-item-icon>
              <v-icon small>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group
          v-if="visibleReportMenuItems.length"
          v-model="reportsOpen"
          prepend-icon="mdi-chart-bar"
          color="white"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Reportes</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="item in visibleReportMenuItems"
            :key="item.title"
            :to="item.route"
            link
            class="drawer-item"
            active-class="drawer-item--active"
          >
            <v-list-item-icon>
              <v-icon small>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group
          v-if="visibleUserManagementMenuItems.length"
          v-model="userManagementOpen"
          prepend-icon="mdi-account-cog-outline"
          color="white"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Gestión de usuarios</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="item in visibleUserManagementMenuItems"
            :key="item.title"
            :to="item.route"
            link
            class="drawer-item"
            active-class="drawer-item--active"
          >
            <v-list-item-icon>
              <v-icon small>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>

      <template v-slot:append>
        <v-list dense nav>
          <v-list-item>
            <v-list-item-content>
              <v-select
                v-model="selectedTimezone"
                :items="timezoneOptions"
                item-text="label"
                item-value="value"
                label="Zona horaria"
                dense
                outlined
                hide-details
                dark
                class="timezone-select mb-2"
                @change="handleTimezoneChange"
              ></v-select>
            </v-list-item-content>
          </v-list-item>
           <v-list-item @click="changeOperator" link>
            <v-list-item-icon>
              <v-icon>mdi-account-switch</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Cambiar usuario</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
           <v-list-item @click="logout" link>
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Cerrar sesión</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>

    </v-navigation-drawer>

    <v-app-bar app color="white" flat class="border-bottom tenant-header">
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>

      <div class="tenant-header__business d-flex align-center">
        <v-icon color="primary" class="mr-2">mdi-store-outline</v-icon>
        <span class="text-subtitle-1 font-weight-medium grey--text text--darken-3">
          {{ businessName }}
        </span>
      </div>

      <v-spacer></v-spacer>

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text rounded class="text-none px-2" v-bind="attrs" v-on="on">
            <v-avatar color="accent" size="34" class="mr-2">
              <span class="white--text text-caption font-weight-bold">{{ userInitials }}</span>
            </v-avatar>
            <span class="d-none d-sm-inline grey--text text--darken-3">{{ operatorName || 'Usuario' }}</span>
            <v-icon small right color="grey">mdi-chevron-down</v-icon>
          </v-btn>
        </template>
         <v-list dense>
            <v-list-item @click="changeOperator">
              <v-list-item-icon>
                <v-icon small color="primary">mdi-account-switch</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Cambiar usuario</v-list-item-title>
            </v-list-item>
            <v-list-item @click="logout">
              <v-list-item-icon>
                <v-icon small color="error">mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Cerrar sesión</v-list-item-title>
            </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main class="grey lighten-4">
      <!-- El contenido principal se renderizará aquí -->
      <router-view @show-alert="(options) => $emit('show-alert', options)"/>
    </v-main>
  </div>
</template>

<script>
import axios from '../plugins/axios';
import { clearOperatorSession, getActiveOperator } from '@/services/posOperatorService';
import { canAccessOperatorPath } from '@/utils/operatorPermissions';

export default {
  name: 'AppDashboard',
  data() {
    return {
      drawer: true, // Mantenemos el drawer visible por defecto en pantallas grandes
      inventoryOpen: true,
      reportsOpen: true,
      userManagementOpen: true,
      selectedTimezone: 'America/Mexico_City',
      timezoneOptions: [
        { label: 'Ciudad de México', value: 'America/Mexico_City' },
        { label: 'Monterrey', value: 'America/Monterrey' },
        { label: 'Tijuana', value: 'America/Tijuana' },
        { label: 'Bogotá', value: 'America/Bogota' },
        { label: 'Lima', value: 'America/Lima' },
        { label: 'Santiago', value: 'America/Santiago' },
        { label: 'Buenos Aires', value: 'America/Argentina/Buenos_Aires' },
        { label: 'Madrid', value: 'Europe/Madrid' },
        { label: 'UTC', value: 'UTC' },
      ],
      userRole: null,
      userName: null,
      operatorName: null,
      businessName: null,
      menuItems: [
        { title: 'Dashboard', icon: 'mdi-view-dashboard', route: '/admin/dashboard' },
        { title: 'Punto de venta', icon: 'mdi-point-of-sale', route: '/admin/pos' },
        { title: 'Cotizaciones', icon: 'mdi-file-document-edit-outline', route: '/admin/quotations' },
        { title: 'Promociones', icon: 'mdi-sale', route: '/admin/promotions' },
        { title: 'Cierre de caja', icon: 'mdi-cash-register', route: '/admin/cash-closure' },
        { title: 'Tickets', icon: 'mdi-receipt', route: '/admin/sales' },
        { title: 'Clientes', icon: 'mdi-account-group-outline', route: '/admin/clients' }, // Ajusta la ruta si es necesario
        { title: 'Historial de atención', icon: 'mdi-clipboard-pulse-outline', route: '/admin/customer-history' },
        { title: 'Puentes de impresión', icon: 'mdi-printer-pos', route: '/admin/print-bridges' },
        { title: 'Configuración', icon: 'mdi-cog-outline', route: '/admin/settings' }, // Ajusta la ruta si es necesario
      ],
      inventoryMenuItems: [
        { title: 'Productos', icon: 'mdi-package-variant-closed', route: '/admin/products' },
        { title: 'Categorías', icon: 'mdi-shape-outline', route: '/admin/categories' },
        { title: 'Gestión de inventario', icon: 'mdi-warehouse', route: '/admin/inventory' },
      ],
      reportMenuItems: [
        { title: 'Ventas', icon: 'mdi-cash-multiple', route: '/admin/reports/sales' },
        { title: 'Inventario', icon: 'mdi-clipboard-list-outline', route: '/admin/reports/inventory' },
        { title: 'Clientes', icon: 'mdi-account-box-multiple-outline', route: '/admin/reports/clients' },
      ],
      userManagementMenuItems: [
        { title: 'Roles y Permisos', icon: 'mdi-shield-account-outline', route: '/admin/roles-permissions' },
        { title: 'Usuarios', icon: 'mdi-account-multiple-outline', route: '/admin/pos-users' },
      ],
    };
  },
  computed: {
    userInitials() {
      return String(this.operatorName || 'U')
        .split(/\s+/)
        .slice(0, 2)
        .map((w) => w.charAt(0).toUpperCase())
        .join('');
    },
    visibleMenuItems() {
      return this.menuItems.filter(item => canAccessOperatorPath(item.route));
    },
    visibleInventoryMenuItems() {
      return this.inventoryMenuItems.filter(item => canAccessOperatorPath(item.route));
    },
    visibleReportMenuItems() {
      return this.reportMenuItems.filter(item => canAccessOperatorPath(item.route));
    },
    visibleUserManagementMenuItems() {
      return this.userManagementMenuItems.filter(item => canAccessOperatorPath(item.route));
    },
    hasModuleGroups() {
      return Boolean(
        this.visibleInventoryMenuItems.length
        || this.visibleReportMenuItems.length
        || this.visibleUserManagementMenuItems.length
      );
    },
  },
  created() {
    this.loadUserInfo();
    this.loadBusinessContext();
    this.loadTimezonePreference();
  },
  methods: {
    loadTimezonePreference() {
      const savedTimezone = localStorage.getItem('appTimezone');
      if (savedTimezone) {
        this.selectedTimezone = savedTimezone;
      } else {
        localStorage.setItem('appTimezone', this.selectedTimezone);
      }
    },
    handleTimezoneChange(timezone) {
      localStorage.setItem('appTimezone', timezone);
      window.dispatchEvent(new CustomEvent('app-timezone-changed', { detail: timezone }));
    },
    loadUserInfo() {
      const token = localStorage.getItem('token');
      const userRole = localStorage.getItem('userRole');
      const userName = localStorage.getItem('userName');
      const businessName = localStorage.getItem('businessName');
      
      // Verificación básica: si no hay token, el guard de ruta ya debería haber redirigido
      // Pero podemos mantener una comprobación aquí por si acaso o para cargar datos.
      if (!token) { 
         console.error("Dashboard accedido sin token."); // Opcional: loguear si esto ocurre
         this.logout(); // Forzar logout si se llega aquí sin token
         return;
      }
      
      this.userRole = userRole;
      this.userName = userName;
      this.operatorName = getActiveOperator()?.name || null;
      this.businessName = businessName;
    },

    async loadBusinessContext() {
      try {
        const { data } = await axios.get('/api/auth/me');
        if (data.business?.name) {
          this.businessName = data.business.name;
          localStorage.setItem('businessId', String(data.business.id));
          localStorage.setItem('businessName', data.business.name);
        }
      } catch (error) {
        console.warn('No se pudo cargar el nombre del negocio para el header.', error);
      }
    },
    
    logout() {
      clearOperatorSession();
      localStorage.removeItem('token');
      localStorage.removeItem('userRole');
      localStorage.removeItem('userId');
      localStorage.removeItem('userName');
      localStorage.removeItem('businessId');
      localStorage.removeItem('businessName');
      localStorage.removeItem('mustChangePassword');
      this.$router.push('/login');
    },
    changeOperator() {
      clearOperatorSession();
      this.$router.push('/operator-select');
    }
  }
};
</script>

<style scoped>
/* Drawer con degradado azul marino -> azul base */
.app-drawer {
  background: linear-gradient(180deg, #002a54 0%, #003366 55%, #004a8f 100%) !important;
}

.drawer-logo {
  display: block;
  width: 100%;
  max-height: 84px;
  object-fit: contain;
  margin: 4px auto 0;
}

.drawer-section {
  color: rgba(255, 255, 255, 0.45);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 1.2px;
  padding: 10px 12px 4px;
}

.drawer-item {
  border-radius: 8px;
  margin-bottom: 2px;
}

/* Item activo: fondo translúcido + barra de acento azul agua */
.drawer-item--active {
  background: rgba(0, 188, 212, 0.16) !important;
  color: #4DD0E1 !important;
  position: relative;
}

.drawer-item--active::before {
  opacity: 0 !important;
}

.drawer-item--active::after {
  content: '';
  position: absolute;
  left: 0;
  top: 20%;
  height: 60%;
  width: 3px;
  border-radius: 3px;
  background: #00BCD4;
  opacity: 1;
}

.drawer-item--active .v-icon {
  color: #4DD0E1 !important;
}

.border-bottom {
  border-bottom: 1px solid #e0e0e0 !important;
}

.timezone-select {
  min-width: 200px;
}

.v-navigation-drawer ::-webkit-scrollbar {
  width: 0px;
}

.v-navigation-drawer {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;  /* Internet Explorer 10+ */
}

.tenant-layout {
  display: contents;
}

.tenant-header__business {
  max-width: min(480px, 50vw);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style> 